var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7532 18.628C13.6041 19.1778 14.6181 19.4174 15.6247 19.3065C16.6312 19.1956 17.5689 18.741 18.2801 18.0191L18.9019 17.4102C19.1745 17.131 19.3271 16.756 19.3271 16.3654C19.3271 15.9749 19.1745 15.5999 18.9019 15.3206L16.2628 12.7052C15.9863 12.433 15.6142 12.2805 15.2265 12.2805C14.8389 12.2805 14.4667 12.433 14.1902 12.7052V12.7052C13.9114 12.9782 13.537 13.131 13.147 13.131C12.7571 13.131 12.3827 12.9782 12.1038 12.7052L7.95865 8.5536C7.82037 8.41711 7.71056 8.25446 7.63561 8.0751C7.56066 7.89573 7.52206 7.70323 7.52206 7.50879C7.52206 7.31435 7.56066 7.12185 7.63561 6.94248C7.71056 6.76311 7.82037 6.60046 7.95865 6.46398V6.46398C8.23037 6.18707 8.38263 5.81434 8.38263 5.42609C8.38263 5.03784 8.23037 4.66511 7.95865 4.3882L5.33337 1.75888C5.05454 1.48587 4.6801 1.33301 4.29016 1.33301C3.90023 1.33301 3.52578 1.48587 3.24696 1.75888L2.639 2.38162C1.91822 3.09394 1.4643 4.03311 1.35358 5.0412C1.24286 6.04928 1.48209 7.06481 2.03104 7.91702C4.89128 12.1388 8.5306 15.7743 12.7532 18.628V18.628Z",
    stroke: "#0000AC",
    strokeWidth: 1.33295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlue);
export default __webpack_public_path__ + "static/media/phone-blue.b0c7d8d9db24406cad18087d0d23c594.svg";
export { ForwardRef as ReactComponent };